import React from "react";
import BaseButton from "./BaseButton";
import { SaveOutlined } from '@ant-design/icons';


const BaseCreate = (props) => <BaseButton type="primary" { ...props }>{ props.text ? props.text : "Save" } <SaveOutlined /></BaseButton>

export default BaseCreate;
